"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const assetsAreLoaded_1 = __importDefault(require("../assetsAreLoaded"));
const updateCootsVelocity_1 = __importDefault(require("./updateCootsVelocity"));
const updateCootsPosition_1 = __importDefault(require("./updateCootsPosition"));
const gameIsOngoing_1 = __importDefault(require("../gameIsOngoing"));
const isCatStarving_1 = __importDefault(require("../isCatStarving"));
const getAudioSources_1 = __importDefault(require("../definables/getAudioSources"));
const state_1 = __importDefault(require("../../state"));
const levelIsCompleted_1 = __importDefault(require("../levelIsCompleted"));
const getAudioSource_1 = __importDefault(require("../definables/getAudioSource"));
const isPaused_1 = __importDefault(require("../isPaused"));
const update = () => {
    var _a, _b, _c, _d, _e;
    if ((0, assetsAreLoaded_1.default)()) {
        if ((0, gameIsOngoing_1.default)()) {
            if ((0, levelIsCompleted_1.default)()) {
                const mainMusic = (0, getAudioSource_1.default)("music/main");
                const levelMusic = (0, getAudioSource_1.default)("music/level");
                if (levelMusic.isPlaying() === false && state_1.default.playedLevelMusic === false) {
                    mainMusic.stop();
                    levelMusic.play(null, null);
                    state_1.default.playedLevelMusic = true;
                }
                (_a = document.getElementById("screen")) === null || _a === void 0 ? void 0 : _a.classList.remove("main");
                (_b = document.getElementById("screen")) === null || _b === void 0 ? void 0 : _b.classList.add("level");
            }
            else if (state_1.default.isInBed === false && (0, isPaused_1.default)() === false) {
                (0, updateCootsVelocity_1.default)();
                (0, updateCootsPosition_1.default)();
            }
        }
        else if ((0, isCatStarving_1.default)()) {
            (_c = document.getElementById("screen")) === null || _c === void 0 ? void 0 : _c.classList.remove("main");
            (_d = document.getElementById("screen")) === null || _d === void 0 ? void 0 : _d.classList.add("defeat");
            (0, getAudioSources_1.default)().forEach((audioSource) => {
                audioSource.cancelOnEnds();
            });
            const mainMusic = (0, getAudioSource_1.default)("music/main");
            const defeatMusic = (0, getAudioSource_1.default)("music/defeat");
            if (mainMusic.isPlaying() && state_1.default.playedDefeatMusic === false) {
                mainMusic.stop();
                defeatMusic.play(null, null);
                state_1.default.playedDefeatMusic = true;
            }
        }
        else if (state_1.default.won) {
            (_e = document.getElementById("screen")) === null || _e === void 0 ? void 0 : _e.classList.add("victory");
        }
    }
};
exports.default = update;
